import { vservice } from '@niknevis/vue-modules'
import { PanelInvoiceRoute } from '@/modules/invoice/routes/panel-invoice.route'
import { HTTP } from '@/modules/shared/helpers/http/facades/http'
import { PaymentLinkRequest, StartPaymentResource } from '@/modules/transaction/models/payment.model'
import { Data } from '@/modules/shared/models/data'

@vservice()
export class PanelInvoiceService {
  constructor(
    private readonly routes: PanelInvoiceRoute
  ) {
  }

  // export(data) {
  //   return HTTP.get(
  //     this.routes.export(),
  //     data
  //   )
  // }

  paymentLink(id: number, data: PaymentLinkRequest): Promise<Data<StartPaymentResource>> {
    return HTTP
      .post(
        this.routes.paymentLink(id),
        data
      ).then(result => result.json())
  }

}
